export default async function ({app, $auth, $axios, route}) {
  // _switch_user-Header setzen und User (neu) laden; schlägt das fehl, Header wieder entfernen.
  // Mit _token (EasyAdmin "Login als Kandidat"): erst mit dem übergebenen Token einloggen,
  // der hat Vorrang vor einer evtl. bestehenden Session. Der Header muss VOR setUserToken
  // gesetzt sein, weil setUserToken intern fetchUser() aufruft.
  if (
    route.path === '/' &&
    route.query._switch_user &&
    (route.query._token || $auth.loggedIn)
  ) {
    $axios.defaults.headers.common['_switch_user'] = route.query._switch_user;
    const authenticate = route.query._token
      ? $auth.setUserToken(route.query._token, route.query._refresh_token)
      : $auth.fetchUser();
    await authenticate.catch(() => {
      delete $axios.defaults.headers.common['_switch_user'];
    });
  }

  // remove _switch_user and token params from url
  app.router.beforeEach((to, from, next) => {
    if (to.query._switch_user || to.query._token) {
      const query = {...to.query};
      delete query._switch_user;
      delete query._token;
      delete query._refresh_token;
      next({...to, query});
    } else {
      next();
    }
  });
}
